(function () {
    const persistir = config.hasOwnProperty("salvarDados")
        ? config.salvarDados
        : true;
    if (!persistir) {
        localStorage.clear();
    }
    const api = PersistanceService.Create();

    window.scorm = api;
    window.bridge = new EventEmitter();
    window.view = new ViewController(
        document.querySelector("#main"),
        config,
        api
    );

    if (config.debug) Debuggy(window.view);
})();
